// src/vy-error.ts
var VyError = class extends Error {
  constructor(message, metadata, originalError) {
    super(message);
    this.metadata = metadata;
    this.originalError = originalError;
  }
};

// src/vy-errors/vy-internal-api-error.ts
var VyInternalApiError = class extends VyError {
  constructor(userMessage, vyError) {
    super(vyError.message, { userMessage, vyError }, vyError.originalError);
    this.userMessage = userMessage;
    this.vyError = vyError;
  }
};

// src/vy-errors/database-error/vy-database-error.ts
var VyDatabaseError = class _VyDatabaseError extends VyError {
  constructor(message, originalError, query, metadata) {
    super(message, { query, ...metadata }, originalError);
    Object.setPrototypeOf(this, _VyDatabaseError.prototype);
  }
};

// src/vy-errors/database-error/database-errors/resource-not-found-error/vy-resource-not-found-error.ts
var VyResourceNotFoundError = class _VyResourceNotFoundError extends VyDatabaseError {
  constructor(message, originalError, metadata, query) {
    super(message, originalError, query, metadata);
    Object.setPrototypeOf(this, _VyResourceNotFoundError.prototype);
  }
  static isError(error) {
    return error instanceof _VyResourceNotFoundError;
  }
};

// src/vy-errors/database-error/database-errors/resource-not-found-error/resource-not-found-errors/vy-customer-not-found-error.ts
var VyCustomerNotFoundError = class _VyCustomerNotFoundError extends VyResourceNotFoundError {
  constructor(originalError, customerId, query) {
    super("Customer not found", originalError, { customerId }, query);
    Object.setPrototypeOf(this, _VyCustomerNotFoundError.prototype);
  }
};

// src/vy-errors/database-error/database-errors/resource-not-found-error/resource-not-found-errors/vy-plan-not-found-error.ts
var VyPlanNotFoundError = class _VyPlanNotFoundError extends VyResourceNotFoundError {
  constructor(originalError, planId, query) {
    super("Plan not found", originalError, { planId }, query);
    Object.setPrototypeOf(this, _VyPlanNotFoundError.prototype);
  }
};

// src/vy-errors/database-error/database-errors/resource-not-found-error/resource-not-found-errors/vy-contract-not-found-error.ts
var VyContractNotFoundError = class _VyContractNotFoundError extends VyResourceNotFoundError {
  constructor(originalError, contractId, query) {
    super("Contract not found", originalError, { contractId }, query);
    Object.setPrototypeOf(this, _VyContractNotFoundError.prototype);
  }
};

// src/vy-errors/database-error/database-errors/resource-not-found-error/resource-not-found-errors/vy-report-not-found-error.ts
var VyReportNotFoundError = class _VyReportNotFoundError extends VyResourceNotFoundError {
  constructor(originalError, reportId, query) {
    super("Report not found", originalError, { reportId }, query);
    Object.setPrototypeOf(this, _VyReportNotFoundError.prototype);
  }
};

// src/vy-errors/database-error/database-errors/resource-not-found-error/resource-not-found-errors/vy-invoice-not-found-error.ts
var VyInvoiceNotFoundError = class _VyInvoiceNotFoundError extends VyResourceNotFoundError {
  constructor(originalError, invoiceId, query) {
    super("Invoice not found", originalError, { invoiceId }, query);
    Object.setPrototypeOf(this, _VyInvoiceNotFoundError.prototype);
  }
};

// src/vy-errors/database-error/database-errors/resource-not-found-error/resource-not-found-errors/vy-user-not-found-error.ts
var VyUserNotFoundError = class _VyUserNotFoundError extends VyResourceNotFoundError {
  constructor(originalError, userId, query) {
    super("User not found", originalError, { userId }, query);
    Object.setPrototypeOf(this, _VyUserNotFoundError.prototype);
  }
};

// src/vy-errors/database-error/database-errors/resource-not-found-error/resource-not-found-errors/vy-product-not-found-error.ts
var VyProductNotFoundError = class _VyProductNotFoundError extends VyResourceNotFoundError {
  constructor(originalError, productId, query) {
    super("Product not found", originalError, { productId }, query);
    Object.setPrototypeOf(this, _VyProductNotFoundError.prototype);
  }
};

// src/vy-errors/database-error/database-errors/conflict-error/vy-conflict-error.ts
var VyConflictError = class _VyConflictError extends VyDatabaseError {
  constructor(message, originalError, query, metadata) {
    super(message, originalError, query, metadata);
  }
  static isError(error) {
    return error instanceof _VyConflictError;
  }
};

// src/vy-errors/database-error/database-errors/conflict-error/vy-conflict-errors/customer-conflict-error/customer-conflict-error.ts
var VyCustomerConflictError = class _VyCustomerConflictError extends VyConflictError {
  constructor(type, originalError, query, metadata) {
    super("Customer already exists", originalError, query, metadata);
    this.type = type;
    Object.setPrototypeOf(this, _VyCustomerConflictError.prototype);
  }
};

// src/vy-errors/database-error/database-errors/conflict-error/vy-conflict-errors/customer-conflict-error/customer-conflict-error-types.ts
var CUSTOMER_CONFLICT_ERROR_TYPES = {
  CUSTOMER_ALREADY_EXISTS: "CUSTOMER_ALREADY_EXISTS",
  EXTERNAL_ID_ALREADY_EXISTS: "EXTERNAL_ID_ALREADY_EXISTS"
};

// src/vy-errors/database-error/database-errors/conflict-error/vy-conflict-errors/label-conflict-error/label-conflict-error.ts
var VyLabelConflictError = class _VyLabelConflictError extends VyConflictError {
  constructor(originalError, metadata) {
    super("Label already exists", originalError, void 0, metadata);
    Object.setPrototypeOf(this, _VyLabelConflictError.prototype);
  }
};

// src/vy-errors/runtime-error/vy-runtime-error.ts
var VyRuntimeError = class extends VyError {
  constructor(message, originalError, metadata) {
    super(message, metadata, originalError);
  }
};

// src/vy-errors/runtime-error/runtime-errors/vy-element-not-error.ts
var VyElementNotFoundError = class _VyElementNotFoundError extends VyRuntimeError {
  constructor(message, originalError) {
    super(message, originalError);
    Object.setPrototypeOf(this, VyRuntimeError.prototype);
  }
  static isError(error) {
    return error instanceof _VyElementNotFoundError;
  }
};

// src/vy-errors/runtime-error/runtime-errors/vy-property-not-found-error.ts
var VyPropertyNotFoundError = class _VyPropertyNotFoundError extends VyRuntimeError {
  constructor(message, originalError) {
    super(message, originalError);
    Object.setPrototypeOf(this, VyRuntimeError.prototype);
  }
  static isError(error) {
    return error instanceof _VyPropertyNotFoundError;
  }
};

// src/vy-errors/runtime-error/runtime-errors/vy-serialize-error.ts
var VySerializeError = class _VySerializeError extends VyRuntimeError {
  constructor(message, originalError) {
    super(message, originalError);
    Object.setPrototypeOf(this, VyRuntimeError.prototype);
  }
  static isError(error) {
    return error instanceof _VySerializeError;
  }
};

// src/vy-errors/runtime-error/runtime-errors/vy-validation-error.ts
var VyValidationError = class _VyValidationError extends VyRuntimeError {
  constructor(message, originalError) {
    super(message, originalError);
    Object.setPrototypeOf(this, VyRuntimeError.prototype);
  }
  static isError(error) {
    return error instanceof _VyValidationError;
  }
};

// src/vy-errors/runtime-error/runtime-errors/json-invalid-error.ts
var JsonInvalidError = class extends VyRuntimeError {
  constructor(json) {
    super("invalid json", void 0, { json });
  }
};

// src/vy-errors/runtime-error/runtime-errors/vy-unexpected-value-error.ts
var VyUnexpectedValueError = class extends VyRuntimeError {
  constructor(field, value) {
    super(`Unexpected value`, void 0, { field, value });
  }
};

// src/vy-errors/api-error/vy-api-error.ts
var VyApiError = class extends VyError {
  constructor(message, statusCode, metadata) {
    super(message, { ...metadata, statusCode });
  }
};

// src/vy-errors/api-error/vy-api-errors/vy-bad-request-error.ts
import { StatusCodes } from "http-status-codes";
var VyBadRequestError = class extends VyApiError {
  constructor(message, metadata) {
    super(message, StatusCodes.BAD_REQUEST, metadata);
  }
};

// src/vy-errors/api-error/vy-api-errors/vy-forbidden-error.ts
import { StatusCodes as StatusCodes2 } from "http-status-codes";
var VyForbiddenError = class extends VyApiError {
  constructor(message, metadata) {
    super(message, StatusCodes2.FORBIDDEN, metadata);
  }
};

// src/vy-errors/api-error/vy-api-errors/vy-unauthorized-error.ts
import { StatusCodes as StatusCodes3 } from "http-status-codes";
var VyUnauthorizedError = class extends VyApiError {
  constructor(message, metadata) {
    super(message, StatusCodes3.UNAUTHORIZED, metadata);
  }
};

// src/vy-errors/integration-error/vy-integration-error.ts
var VyIntegrationError = class extends VyError {
  constructor(message, provider, integrationError) {
    super(message, { provider }, integrationError);
  }
};

// src/vy-errors/integration-error/vy-integration-errors/vy-netsuite-error.ts
var VyNetsuiteError = class extends VyIntegrationError {
  constructor(errorDetails, integrationError) {
    const message = errorDetails.join("\n");
    super(message, "Netsuite", integrationError);
  }
};
export {
  CUSTOMER_CONFLICT_ERROR_TYPES,
  JsonInvalidError,
  VyApiError,
  VyBadRequestError,
  VyConflictError,
  VyContractNotFoundError,
  VyCustomerConflictError,
  VyCustomerNotFoundError,
  VyDatabaseError,
  VyElementNotFoundError,
  VyError,
  VyForbiddenError,
  VyInternalApiError,
  VyInvoiceNotFoundError,
  VyLabelConflictError,
  VyNetsuiteError,
  VyPlanNotFoundError,
  VyProductNotFoundError,
  VyPropertyNotFoundError,
  VyReportNotFoundError,
  VyResourceNotFoundError,
  VyRuntimeError,
  VySerializeError,
  VyUnauthorizedError,
  VyUnexpectedValueError,
  VyUserNotFoundError,
  VyValidationError
};
